<template>
  <Menu></Menu>
  <div id="box">
    <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
    <!-- =========================================================================================================== -->
    <div class="container mb-2">
      <div class="row p-0">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block">Manage Access <i class="bi-key-fill"></i> {{ user_name }}</h5>
          <hr>
        </div>
      </div>
      <!-- =========================================================================================================== -->  
      <div class="row mb-2 p-0">
        
        <div class="col p-0">
          <RouterLink class="btn btn-primary bi-arrow-left w-100" to="/users">&nbsp; Back to all users</RouterLink>
        </div>
        
        <div class="col p-0">
        </div>
        
        <div class="col">
          <button class="btn btn-success bi-floppy w-100" @click="savePriviledge()" :disabled="loading">&nbsp; Save</button>
        </div>

      </div>
      <!-- =========================================================================================================== -->  
      <div class="row mb-2 p-0">
        <div class="col p-0">
          <hr>
        </div>
      </div>
      <!-- =========================================================================================================== FIXME -->  
      <div class="row mb-2 p-0">
        
        <div class="col p-0">
          <div class="input-group w-100 mb-2">
              <span class="input-group-text w-50">Max Discount 0 - 100</span>
              <input class="form-control text-center" type="number" v-model.number="max_discount">
            </div>
        </div>
        
        <div class="col p-0">
        </div>
        
        <div class="col">
        </div>
        <hr class="m-0">        

      </div>
      <!-- =========================================================================================================== FIXME -->  
      <div class="row mb-2 p-0">
        
        <div class="col-auto text-start p-0 m-1 w-25">
          <div class="input-group w-100">
            <span class="input-group-text w-50">Branches</span>
            <a class="btn btn-primary" @click="setAllBranches(true)">All</a>
            <a class="btn btn-warning" @click="setAllBranches(false)">None</a>
          </div>
        </div>
        
        <div class="col p-0 d-flex align-content-between flex-wrap">
          <div class="input-group w-auto d-flex m-1" v-for="b in access_branches" :key="b._id">
            <span class="input-group-text">
              <input class="branches form-check-input" type='checkbox' :id=b._id v-model=b.has>
            </span>
            <label class="input-group-text flex-fill" :for=b._id>{{b.name}}</label>
          </div>
        </div>
        <hr class="m-0">        
      </div>
      <!-- =========================================================================================================== FIXME -->  
      <div class="row mb-2 p-0">
        
        <div class="col-auto text-start p-0 m-1 w-25">
          <div class="input-group w-100">
            <span class="input-group-text w-50">View Stock</span>
            <a class="btn btn-primary" @click="setAllAccessStock(true)">All</a>
            <a class="btn btn-warning" @click="setAllAccessStock(false)">None</a>
          </div>
        </div>
        
        <div class="col p-0 d-flex align-content-between flex-wrap">
          <div class="input-group w-auto d-flex m-1" v-for="b in access_stock" :key="b._id">
            <span class="input-group-text">
              <input class="branches form-check-input" type='checkbox' :id="'stock'+b._id" v-model=b.has>
            </span>
            <label class="input-group-text flex-fill" :for="'stock'+b._id">{{b.name}}</label>
          </div>
        </div>
        <hr class="m-0">        
      </div>
      <!-- =========================================================================================================== -->  
      <!-- =========================================================================================================== FIXME --> 
      <div class="row mb-2 p-0" v-for="arr, key in operations" :key="key">
        <div class="col-auto text-start p-0 m-1 w-25">
          <div class="input-group w-100">
            <span class="input-group-text w-50">{{ key }}</span>
            <a class="btn btn-primary" @click="setAll(key, true)">All</a>
            <a class="btn btn-warning" @click="setAll(key, false)">None</a>
          </div>
        </div>
        
        <div class="col p-0 d-flex align-content-between flex-wrap">
          <div class="input-group w-auto d-flex m-1" v-for="x in arr" :key="x._id">
            <span class="input-group-text">
              <input class="branches form-check-input" type='checkbox' :id=x._id  v-model=x.has>
            </span>
            <label class="input-group-text flex-fill" :for=x._id>{{x.en}}</label>
          </div>
        </div>
        <hr class="m-0">        
      </div>
      <!-- =========================================================================================================== -->  
    </div>
  </div>

</template>
<!-- ******************************************************** -->
<script>
  export default {
    name: 'PrivilegePage',
    props: {
      id: {
        type: String,
        default: '',
      },
    },
    data(){
      return {
        loading: false,

        user_id: '',
        user_name: '',
        access_branches: [],
        access_stock: [],
        operations: [],
        max_discount: 0,
      }
    },
    async created() {
      // if(!this.$route.params.id){
      //   return this.$router.go(-1);
      // }
      // console.log(this.$route);
      this.user_id = this.$route.params.id;
      await this.loadPrivilege();
    },
    //**********************************************************
    methods:{
      //**********************************************************
      async loadPrivilege(){
        this.loading = true;
        
        this.access_branches = [];
        this.access_stock = [];
        this.operations = [];
        this.max_discount = 0;
        this.user_name = '';
        var ack = await this.$service.getPriviledge({ id: this.user_id });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.user_name = ack.data.user_name;
          this.access_branches = ack.data.access_branches;
          this.access_stock = ack.data.access_stock;
          this.operations = ack.data.operations;
          this.max_discount = ack.data.max_discount;
        }
        this.loading = false;
      },
      //**********************************************************
      async setAllBranches(val){
        this.access_branches.forEach((x)=>x.has = val);
      },
      //**********************************************************
      async setAllAccessStock(val){
        this.access_stock.forEach((x)=>x.has = val);
      },
      //**********************************************************
      async setAll(key, val){
        this.operations[key].forEach((x)=>x.has = val);
      },
      //**********************************************************
      async savePriviledge(){
        this.loading = true;
        await this._savePriviledge();
        this.loading = false;
      },
      //**********************************************************
      async _savePriviledge(){
        var access_branches = this.access_branches.reduce((acc, x)=>{
          if(x.has) acc.push(x._id);
          return acc;
        }, []);
        var access_stock = this.access_stock.reduce((acc, x)=>{
          if(x.has) acc.push(x._id);
          return acc;
        }, []);
        var acl = Object.values(this.operations).reduce((acc, x)=>{

          let part = x.reduce((acc2, x2)=>{
            if(x2.has) acc2.push(x2._id);
            return acc2;
          }, []);
          
          return acc.concat(part);
        }, []);

        var ack = await this.$service.savePriviledge({
          'id': this.user_id,
          'max_discount': this.max_discount,
          'acl': acl,
          'access_branches': access_branches,
          'access_stock': access_stock,
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        this.$toast('Priviledge Saved Successfuly', 'success');
        await this.loadPrivilege();
      },
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
</style>
  